import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import VueQrCodeReader from "vue-qrcode-reader";
import History from '@/components/History'
import AdminLogin from '@/components/AdminLogin'
import Panel from '@/components/Panel'
import AdminNav from '@/components/AdminNav'
import AdminSettings from '@/components/AdminSettings'
import AdminCustomers from '@/components/AdminCustomers'
import AdminUser from '@/components/AdminUser'
import Forwarders from '@/components/Forwarders'
import CheckIn from '@/components/CheckIn'
import MyPage from "../components/MyPage";
import VModal from 'vue-js-modal'
import VueXlsx from 'vue-js-xlsx'
import Datepicker from 'vuejs-datepicker';
import VueBarcodeScanner from 'vue-barcode-scanner'
import VueHtmlToPaper from 'vue-html-to-paper';
import ItemForm from "../components/ItemForm";
Vue.use(VueXlsx)
Vue.use(VueQrCodeReader);
Vue.use(Router)
Vue.use(VModal, { dialog: true })
Vue.use(AdminNav)
Vue.use(Datepicker)
let options = {
  sound: true, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, options)
Vue.use(VueHtmlToPaper);
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/mypage',
      name: 'MyPage',
      component: MyPage
    },
    {
      path: '/admin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/admin/home',
      name: 'Panel',
      component: Panel
    },
    {
      path: '/admin/settings',
      name: 'AdminSettings',
      component: AdminSettings
    },
    {
      path: '/admin/customers',
      name: 'AdminCustomers',
      component: AdminCustomers
    },
    {
      path: '/admin/forwarders',
      name: 'Forwarders',
      component: Forwarders
    },
    {
      path: '/admin/checkin',
      name: 'CheckIn',
      component: CheckIn
    },
    {
      path: '/admin/users',
      name: 'Users',
      component: AdminUser
    },
    {
      path: '/item/form',
      name: 'ItemForm',
      component: ItemForm
    }
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js